// Which feed the Inventory board reads. The board and its panels ask for
// /inventory/... as they always have; the Inventory (Fleetio) page wraps them in a
// provider that sends the same requests to /inventory-fleetio/..., which runs the
// same route code on the Fleetio tables (backend/src/routes/inventoryFleetio.js).
// The cache keys differ too, or one board would show the other's cached answer.
//
// When the file feed retires, this file and the provider go, and the board keeps
// its requests.
import { createContext, useContext } from 'react';
import { api as baseApi } from '../../services/api';

const FILE_FEED = {
  api: baseApi,
  queryKey: (...parts) => parts,
  title: 'Inventory',
};

const toFleetio = (url) => url.replace(/^\/inventory\//, '/inventory-fleetio/');

export const FLEETIO_FEED = {
  api: {
    get: (url, config) => baseApi.get(toFleetio(url), config),
    getBlob: (url, config) => baseApi.getBlob(toFleetio(url), config),
  },
  queryKey: (...parts) => ['inventory-fleetio', ...parts],
  title: 'Inventory (Fleetio)',
  subtitle: 'The same board, from Fleetio directly and loaded each weekday. Being compared with Inventory before that page retires.',
};

const InventorySourceContext = createContext(FILE_FEED);

export const InventorySourceProvider = InventorySourceContext.Provider;
export const useInventorySource = () => useContext(InventorySourceContext);
